import React, { useEffect, useState } from 'react';
import {
  Typography,
  Paper,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import API_URL from '../../settings';
import { useAuth } from '../../context/AuthContext';

function WelfareRecipients() {
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL}/patients?hospital_id=${user.hospital_id}`);
        const data = await res.json();

        // ✅ filter เฉพาะผู้ที่ได้รับสวัสดิการ
        const welfarePatients = data.filter(
          p => p.economy?.welfare === true
        );

        setRecipients(welfarePatients);
      } catch (error) {
        console.error('Failed to fetch welfare recipients:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        รายชื่อผู้ได้รับสวัสดิการ
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>ชื่อ-สกุล</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>อายุ</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>สถานะรายได้</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>อาชีพ</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>หมายเหตุ</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {recipients.length > 0 ? (
              recipients.map(p => (
                <TableRow key={p.id} hover>
                  <TableCell>
                    {p.first_name} {p.last_name}
                  </TableCell>
                  <TableCell>{p.age || '-'}</TableCell>
                  <TableCell>{p.economy?.status || '-'}</TableCell>
                  <TableCell>{p.economy?.occupation || '-'}</TableCell>
                  <TableCell>{p.economy?.notes || '-'}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  ไม่พบข้อมูลผู้ได้รับสวัสดิการ
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default WelfareRecipients;
